// extracted by mini-css-extract-plugin
export default {"box":"FieldAnswer_box__aNZoi","container":"FieldAnswer_container__Kq0Nx","delete":"FieldAnswer_delete__WkkDa"};